import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
//@ts-ignore
import preloader from "../assets/preloader.gif"
import styled from "styled-components";

interface Props {

}

const PreloaderWrapper = styled.div<{ $topbarheight: number, $sidebarwidth: number}>`
  z-index: 2;
  width: 100vw;
  margin:auto;
  height: 100vh;
  //top: ${props => props.$topbarheight}px;
  top: 155px;
  // left: ${props => props.$sidebarwidth}px;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
`

const PreloaderGif = styled.img`
  position: absolute;
  top: 25vh
`

const Preloader : React.FC<Props> = props => {
    const didMountRef = useRef(false);
    const didUnmountRef = useRef(false);
    const [topBarHeight, setTopBarHeight] = useState<number>();
    const [sideBarWidth, setSideBarWidth] = useState<number>();

    useEffect(() => {
        const preventScroll = (e: any) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        document.querySelector("html")?.addEventListener("wheel", preventScroll, {passive: false} )
        if(!didMountRef.current) {
            didMountRef.current = true;
            const topBar = document.querySelector(".fixed-top-mainmenu");
            if(topBar) {
                const height = topBar.clientHeight;
                setTopBarHeight(height)
            }
            const sideBar = document.querySelector(".fixed-top-submenu");
            if(sideBar) {
                const width = sideBar.clientWidth;
                setSideBarWidth(width);
            }

            // document.querySelector("html")?.addEventListener("wheel", preventScroll, {passive: false} )
        }
        return (() => {
            document.querySelector("html")?.removeEventListener("wheel", preventScroll);
            if(didUnmountRef.current) {
                // document.querySelector("html")?.removeEventListener("wheel", preventScroll);
            }else didUnmountRef.current = true;

        })
    }, []);

    return <>
        <PreloaderWrapper id={"preloader"} $topbarheight={topBarHeight || 0} $sidebarwidth={sideBarWidth || 0}>
            <PreloaderGif src={preloader} alt={"...loading"}/>
        </PreloaderWrapper>
    </>
};

export default Preloader
